import React, { FC } from 'react'
import {
  Col,
  FlexboxGrid,
} from 'rsuite'

import { Product } from '../../../utils/types/Product'
import ReviewHistogramPanel from './ReviewHistogramPanel'
import ReviewsPanel from './ReviewsPanel'
import useReviewFetch from '../../../services/useReviewFetch'
import { getTotalOfReviews } from '../../../utils/reviewUtils'

import styles from '../../../styles/SingleProductReviewsSection.module.less'

interface SinglePageReviewsSectionProps {
  product: Product
}

const SingleProductReviewsSection: FC<SinglePageReviewsSectionProps> = (props) => {
  const {
    product,
  } = props

  const { reviews, ratingQuantities, isLoading, loadMoreReviews } = useReviewFetch(product?.id ?? '')
  const reviewTotal = getTotalOfReviews(ratingQuantities)

  const isReviewListEmpty = reviews.length === 0
  const isLoadingInitial = isLoading && isReviewListEmpty
  const isNoReviews = !isLoading && isReviewListEmpty

  if (isNoReviews) {
    return null
  }

  return (
    <FlexboxGrid
      className={`${styles['reviews-grid']} full-w`}
    >
      <FlexboxGrid.Item
        as={Col}
        md={6}
        xs={24}
      >
        <ReviewHistogramPanel
          ratingQuantities={ratingQuantities}
          isLoadingInitial={isLoadingInitial}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as={Col}
        md={18}
        xs={24}
      >
        <ReviewsPanel
          reviews={reviews}
          reviewTotal={reviewTotal}
          isLoading={isLoading}
          isLoadingInitial={isLoadingInitial}
          loadMoreReviews={loadMoreReviews}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  )
}

export default SingleProductReviewsSection
